import styled from "styled-components";

export const Sidebar = styled.div`
width: 250px;
padding: 20px;
`;

export const Menu = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 20px;
`;

export const MenuItem = styled.li`
  margin: 20px 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const MenuContainer = styled.div`
padding: 40px;
background: var(--INYECTABLE, linear-gradient(180deg, #040916 0%, #0B1733 100%));
`  

export const LogoContainer = styled.div`

`